import { Component, computed, input } from '@angular/core';

import { CmsPicture, CmsTarget, CmsTaxonomy } from '@fcom/core-api';

import { findAspectRatio, toLinkData } from '../../services/template/data-mappers';

const DEFAULT_RATIO = '16x9';

interface TextOnImageContent {
  teaserTitle?: string;
  teaserText?: string;
  picture?: CmsPicture;
  target?: CmsTarget;
  subjectTaxonomyTags?: CmsTaxonomy[];
}

@Component({
  selector: 'cms-text-on-image',
  templateUrl: './cms-text-on-image.component.html',
  standalone: false,
})
export class CmsTextOnImageComponent {
  content = input.required<TextOnImageContent>();
  noText = input<boolean>();

  imageData = computed(() => {
    return this.content().picture as CmsPicture;
  });
  cmsTarget = computed(() => {
    return toLinkData(this.content().target);
  });
  imageAspectRatio = computed(() => {
    return findAspectRatio(this.content().subjectTaxonomyTags ?? []) ?? DEFAULT_RATIO;
  });
}
